$('.tego-on-load-modal').showTegoModal();